import {dispatch} from '../store';
import axios from '../../utils/axios';
import API from '../../constant/API';
import {STORAGE_KEY} from '../../constant/StorageConstant';
import * as toolkitRaw from '@reduxjs/toolkit';
import RouteConstant from '@/constant/RouteConstant';

import Cookies from 'js-cookie'

const {createSlice} = toolkitRaw.default ?? toolkitRaw;

export const getToken = () => {
  return localStorage.getItem(STORAGE_KEY.TOKEN) || Cookies.get('wapAccessToken');
}
export const setToken = (token) => {
  if (!token) {
    const domain = window.document.domain;
    const rootDomain = domain.substring(domain.indexOf('.')+1);
    localStorage.removeItem(STORAGE_KEY.TOKEN);
    Cookies.remove('wapAccessToken', { path: '/', domain: `.${rootDomain}` })
    return;
  }
  localStorage.setItem(STORAGE_KEY.TOKEN, token);
}

export const getTmpToken = () => {
  return localStorage.getItem(STORAGE_KEY.TMP_TOKEN);
}
export const setTmpToken = (token) => {
  if (!token) {
    localStorage.removeItem(STORAGE_KEY.TMP_TOKEN);
    return;
  }
  localStorage.setItem(STORAGE_KEY.TMP_TOKEN, token);
}

// taskId 保存2fa任务id
export const getTaskId = () => {
  return localStorage.getItem(STORAGE_KEY.TASK_ID);
}
export const setTaskId = (taskId) => {
  if (!taskId) {
    localStorage.removeItem(STORAGE_KEY.TASK_ID);
    return;
  }
  localStorage.setItem(STORAGE_KEY.TASK_ID, taskId);
}

/**
 * action,
 * params,
 * expand,
 * task,
 * sign,
 */
export const getTaskRuleParams = () => {
  const taskRuleStr = localStorage.getItem(STORAGE_KEY.TASK_RULE_PARAMS);
  if (!taskRuleStr) return null;
  return JSON.parse(taskRuleStr);
}
export const setTaskRuleParams = (taskRule) => {
  if (!taskRule) {
    localStorage.removeItem(STORAGE_KEY.TASK_RULE_PARAMS);
    return;
  }
  localStorage.setItem(STORAGE_KEY.TASK_RULE_PARAMS, JSON.stringify(taskRule));
}
export const clearTaskRule = () => {
  setTaskRuleParams(null);
  setTaskId(null);
}

// ----------------------------------------------------------------------

const initialState = {
  /**
   tokenName: "X-WToken"
   tokenValue: "ba8bf5da-c9c1-4187-ab53-7739d026db03"
   uid: 3518428314
   */
  user: null,
  loading: {},
  guidePassed: false,
  isAuthenticated: !!getToken(),

  // 忘记密码state
  forgotPwState: null,

  zendeskUnreadMessageCount: 0,
  unreadMessageCount: 0,

  homeInfo: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    startLoading(state, {payload: type}) {
      const loading = state.loading;
      loading[type] = true;
      state.loading = {...loading};
    },
    stopLoading(state, {payload: type}) {
      const loading = state.loading;
      loading[type] = false;
      state.loading = {...loading};
    },
    onUserInfo(state, {payload: user}) {
      state.user = {...user};
    },
    onLogout(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
    onForgotPwState(state, {payload}) {
      state.forgotPwState = payload;
    },
    onAppendForgotPwState(state, {payload}) {
      state.forgotPwState = { ...state.forgotPwState, ...payload }
    },

    onHomeInfo(state, {payload}) {
      state.homeInfo = payload;
    },
    onZendeskUnreadMessageCount(state, {payload}) {
      state.zendeskUnreadMessageCount = payload;
    },
    onUnreadMsgCount(state, {payload}) {
      state.unreadMessageCount = payload;
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  stopLoading,
  onUserInfo,
  onLogout,
  onTaskRule,
  
  onForgotPwState,
  onAppendForgotPwState,

  onHomeInfo,
  onZendeskUnreadMessageCount,
  onUnreadMsgCount,
} = slice.actions;

// ---------------------------------------------------------------------

export function getUserInfo() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getUserInfo'));
      const responseData = await axios.post(API.USER_INFO);
      dispatch(slice.actions.onUserInfo(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getUserInfo'));
    }
  };
}

export function onUserLogout(redirectPath) {
  return async () => {
    setToken(null);
    setTmpToken(null);
    setTaskId(null);
    setTaskRuleParams(null);

    dispatch(slice.actions.onLogout());
    localStorage.setItem('algInfo', '')
    window.location.href = redirectPath || RouteConstant.LOGIN;
    // if (window.navigate) {
    //   window.navigate(RouteConstant.LOGIN);
    // }
  }
}

export function refreshUnreadMsgCount() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('onUnreadMsgCount'));
      const responseData = await axios.post(API.MSG_UNREAD_COUNT);
      dispatch(slice.actions.onUnreadMsgCount(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('onUnreadMsgCount'));
    }
  };
}

export function getHomeInfo() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getHomeInfo'));
      const responseData = await axios.post(API.USER_HOME);
      dispatch(slice.actions.onHomeInfo(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getHomeInfo'));
    }
  };
}
